<template>
  <div>
    <shop-head currentPageName="Cart" ref="load_cart"></shop-head>
    <!-- 面包屑 -->
    <!-- <div style="background-color: white; width: 100%; height: 57px;">
      <breadcrumb pageName="Cart"></breadcrumb>
    </div> -->

    <!-- 表格 -->
    <div class="cart-area">
      <div class="container mt-0">
        <!-- 头部 -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="`${$t('全部配件')} (${total_count.total || 0})`" name=3></el-tab-pane>
          <el-tab-pane :label="`${$t('可询价')} (${total_count.rfq || 0})`" name=1></el-tab-pane>
          <el-tab-pane :label="`${$t('可采购')} (${total_count.procurement|| 0})`" name=2></el-tab-pane>
        </el-tabs>


        <!-- 购物车重写 -->
        <div class="xtx-cart-page">
          <div class="cart">
            <table>
              <thead>
                <tr>
                  <th width="120">
                 
                  </th>
                  <th width="400">{{$t('商品信息')}}</th>
                  <th width="200">{{$t('单价')}}</th>
                  <th width="180">{{$t('数量')}}</th>
                  <th width="180">{{$t('小计')}}</th>
                  <th width="140">{{$t('操作')}}</th>
                </tr>
              </thead>
              <!-- 商品列表 -->
              <tbody  v-for="(item,index) in cartList" :key="index">
                  <tr v-if="cartList" class="mt-10">
                    <td>
                      <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="item.checkAll"
                        @change="handleCheckAllChange(item)"
                      />
                    </td>
                      <td><div class="ml-10 fs-20">{{ item.goods[0].supplierName}}</div></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td> 
                  </tr>
                  <tr  v-for="(i,index) in item.goods"  v-if="cartList" :key="index">
                    <td>
                      <el-checkbox 
                        @change="handleCheckedItmeChange(i,item)"
                        v-model="i.isCheck"
                      />
                    </td>
                    <td>
                      <div class="goods">
                        <img :src="i.picture.includes('https')? i.picture:i.companyLogo " alt="" />
                        <div>
                          <!--  <p>{{ lang == "zh" ? scope.row.cname : scope.row.ename }}</p> -->
                          <p class="name ellipsis">
                            {{ lang == "zh" ? i.partsName: i.partsEname}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="tc">
                      <p>&yen;{{ i.price || ''}}</p>
                    </td>
                    <!--  @input="(count) => handeChangeCount(count,i.id)" -->
                    <td class="tc">
                      <!-- <el-input-number 
                      :min="1" 
                      :value="i.quantity"
                      /> -->

                      <el-input-number 
                      v-model="i.quantity" 
                      @change="(count) => handeChangeCount(count,i)"
                      :min="1" 
                       >
                    </el-input-number>
                    </td>
                    <td class="tc">
                      <p class="f16 red">&yen;{{ (i.quantity* i.price).toFixed(2) }}</p>
                    </td>
                    <td class="tc">
                      <p>
                        <el-popconfirm :title="$t('确认删除吗?')" 
                        :confirm-button-text="$t('确认')" 
                        :cancel-button-text="$t('取消')"
                        @confirm="deleteCart(i)">
                          <template #reference>
                            <a href="javascript:;">{{$t('删除')}}</a>
                          </template>
                        </el-popconfirm>
                      </p>
                    </td>
                  </tr>
                  <!-- 暂时显示不出来 -->
                  <tr v-else> 
                    <td colspan="6">
                      <div class="cart-none">
                        <el-empty description="购物车列表为空">
                          <el-button type="primary" @click="$router.push('/')">随便逛逛</el-button>
                        </el-empty>
                      </div>
                    </td>
                  </tr>
           
              </tbody>
              
              
            </table>
          </div>
          <!-- 操作栏 -->
          <div class="action">
            <div class="batch">
              {{ $t('共 {total_count} 件商品，已选择 {choose_count} 件，商品合计', { total_count: 0, choose_count: 0 }) }}
<!--               
              共 {{ totle_goods }} 件商品，已选择
              {{ choose_totle }} 件，商品合计： -->
              <span class="red">¥ {{ total_price }} </span>
            </div>
            <div class="total">
              <el-button type="danger" @click = dels_goods>{{$t('批量删除')}}</el-button>
              <el-button size="large" type="primary">{{$t('下单结算')}}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
import breadcrumb from '../../components/common/breadcrumb'
import { getCarList, Add_good, del_good ,count_list } from '../../apis/carList'
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb
  },
  data() {
    return {
      cartList: [],
      couponCode: '',
      selectData: [],
      activeName: 'first',
      isIndeterminate:false,
      totle_goods:0,
      dels:[],
      total_count : {}
    }
  },
  computed: {
    subtotal() {
      let count = 0;
      this.cartList.forEach(item => {
        count += this.$utils.accMul(item.quantity, item.price);
      })
      return count;
    },
    // 选中数量统计
    choose_totle(){
      return  this.selectData.length
    },
    // 计算总共价格 
    total_price(){
      let total = 0 ;
      this.selectData.map((item)=>{
        total += item.price
      })
        return  total
    }

      
  },
  mounted() {
 
    this.initData();
    this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
  },
  methods: {
    handleSelectionChange(data) {
      this.selectData = data;
    },
    gotoPay() {
      if (this.selectData.length === 0) {
        this.$message.warning('Please select an order item');
        return;
      }
      let id = [];
      let obj = {}
      this.selectData.forEach(item => {
        id.push(item.id);
        obj[item.id] = {
          num: item.quantity
        };
      })
      window.sessionStorage.setItem('payItemId', id.join());
      window.sessionStorage.setItem('payItemNum', JSON.stringify(obj));
      this.$router.push({
        path: '/payOrder'
      })
    },
    /** 删除 */
    deletCartProduct(index) {
      this.cartList.splice(index, 1);
      this.saveCartData();
      this.$message.success('success')
    },
    /** 保存购物车数据 */
    saveCartData() {
      let idArr = [];
      let obj = {}
      this.cartList.forEach(item => {
        idArr.push(item.id);
        obj[item.id] = {
          num: item.quantity
        }
      });
      window.localStorage.setItem('cartIdArr', idArr.join());
      window.localStorage.setItem('cartIdNum', JSON.stringify(obj));
      this.$store.commit('reduceCartCount');
    },
    /** 初始化购物车数据 */
    async initData(type = 3) {
      this.$refs.load_cart.$refs.head.getCarListData()

      this.selectData = []
      this.total_count = (await count_list()).data
      const res = await getCarList(type);
      this.cartList = this.car_list_data(res.data)
    
    },
    // 购物车数据处理
    car_list_data(data) {
      let count = 0;
      const res = Object.keys(data).map(key => ({
        company_id: key,
        checkAll:false,
        goods: data[key].map((item)=>{
          count++;
          const temp = {
            ...item,
            isCheck:false
          }
            return temp;
        })
      }));
      this.totle_goods = count
      return res
    },
    // tabs 控制器
    handleClick(tab) {
      const {name} = tab
      this.initData(name)
    },
    // 表格操作
    handleInquiry(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    async deleteCart({id}){
      console.log(id)
      try {
        const ids = {
            ids:[id]
        }
        await  del_good (ids)
        this.$message({
          message: this.$t('删除成功'),
          type: 'success'
        });
        this.initData()
      }catch(e){
        this.$message.error(e.message);
      }
     
     
    },
    // 判断是否全选
    handleCheckAllChange(item){
      const  item_id  = item.goods.map((i) => {
          let data = {
            id:i.id,
            price:i.price*i.quantity
          } 
        return data});
      // const  ids =   item.goods.map((i) =>(i.id))
        item.goods.forEach((item)=>{
          item.isCheck = false
        })
        // 使用 filter 和 includes 过滤掉 b 中存在的元素
        let itemIdSet = new Set(item_id.map(obj => obj.id));
        let c = this.selectData.filter(item => !itemIdSet.has(item.id));
        this.selectData = c
      if(item.checkAll){
        item.goods.forEach((item)=>{
          item.isCheck = true
        })

        this.selectData.push(...item_id) 
      }
      console.log(this.selectData)
    },
    // 单项选择
    handleCheckedItmeChange(i,parent){  
      // 判断是否全选 
      this.isAllChildTrue(parent)
      if(!i.isCheck){
        let DelIndex = this.selectData.findIndex(item => item.id  === i.id);
        if (DelIndex !== -1) {
          this.selectData.splice(DelIndex, 1);
        }
      }else{
          this.selectData.push({
            id:i.id,
            price:i.price*i.quantity
          }) 
      }
      // 判断子元素中的ischeack属性是否都是未true
     console.log(this.selectData)
     
    },
    // 数量
    async handeChangeCount(count,i){
      // 数量添加 i.partsId
      const {id,price,partsId} = i
      const  res  =  await Add_good ({
        partsId: partsId,
        quantity:count
      })

      // 如果被选中，更新数据
        this.selectData.find(item=>{
          if(item.id == id){
            item.price = price*count
          }
        })

      

    },
    // 批量删除
    async dels_goods(){
      let dels =[] 
       this.selectData.forEach((item)=>{
        dels.push(item.id)
      })
      try{
          const data =  {
            ids:dels
        }
        await  del_good (data)
        this.$message({
          message: this.$t('删除成功'),
          type: 'success'
        });
        this.initData()
      }catch(e){
        this.$message.error(e.message);
      }
    },
    // 判断子元素
    isAllChildTrue (data){
      data.checkAll =  data.goods.every(item=>item.isCheck)
    }

    
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-area {
  border-top: 1px solid #ebebeb;
  padding-top: 25px;

  li {
    display: inline-block;
    padding: 0 10px;
    position: relative;

    &:first-child {
      padding-left: 0;
    }

    a {
      color: #333;
    }
  }
}

.cart-area {
  background-color: white;

  ::v-deep .el-table {
    color: #333;
    font-size: 16px;
    font-weight: 500;

    thead {
      color: #333;
    }
  }

  .table-img {
    width: 100px;
  }

  .coupon-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .coupon-input {
      width: 120px;
      margin-top: 30px;
      vertical-align: middle;
      margin-right: 5px;

      ::v-deep .el-input__inner {
        &:focus {
          border-color: #fed100;
        }
      }
    }
  }

  .coupon-btn {
    width: auto;
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    background-color: #333333;
    border: 0 none;
    border-radius: 2px;
    display: inline-block;
    cursor: pointer;
    letter-spacing: 1px;
    padding: 0 25px;
    text-transform: uppercase;
    vertical-align: middle;
    margin-top: 30px;

    &:hover {
      background: #fed100;
    }
  }

  .cart-page-total {
    padding-top: 30px;
    font-size: 25px;
    font-weight: 700;
    margin-bottom: 20px;
    text-transform: capitalize;
  }

  ul {
    border: 1px solid #ebebeb;

    li {
      list-style: none;
      font-size: 15px;
      padding: 10px 30px;
      border-bottom: 1px solid #ebebeb;
      font-weight: 700;

      &:last-child {
        border: 0;
      }

      span {
        float: right;
      }
    }
  }
}

.xtx-cart-page {
  margin-top: 20px;

  .cart {
    background: #fff;
    color: #666;

    table {
      border-spacing: 0;
      border-collapse: collapse;
      line-height: 24px;

      th,
      td {
        padding: 10px;
        border-bottom: 1px solid #f5f5f5;

        &:first-child {
          text-align: left;
          padding-left: 30px;
          color: #999;
        }
      }

      th {
        font-size: 16px;
        font-weight: normal;
        line-height: 50px;
        text-align: center;
      }
    }
  }

  .cart-none {
    text-align: center;
    padding: 120px 0;
    background: #fff;

    p {
      color: #999;
      padding: 20px 0;
    }
  }

  .tc {
    text-align: center;

    a {
      color: #27ba9b;
    }

    .xtx-numbox {
      margin: 0 auto;
      width: 120px;
    }
  }

  .red {
    color: #cf4444;
  }

  .green {
    color: #27ba9b;
  }

  .f16 {
    font-size: 16px;
  }

  .goods {
    display: flex;
    align-items: center;

    img {
      width: 100px;
      height: 100px;
      object-fit: fill;
    }

    >div {
      width: 280px;
      font-size: 16px;
      padding-left: 10px;

      .attr {
        font-size: 14px;
        color: #999;
      }
    }
  }

  .action {
    display: flex;
    background: #fff;
    margin-top: 20px;
    height: 80px;
    align-items: center;
    font-size: 16px;
    justify-content: space-between;
    padding: 0 30px;

    .xtx-checkbox {
      color: #999;
    }

    .batch {
      a {
        margin-left: 20px;
      }
    }

    .red {
      font-size: 18px;
      margin-right: 20px;
      font-weight: bold;
    }
  }

  .tit {
    color: #666;
    font-size: 16px;
    font-weight: normal;
    line-height: 50px;
  }
}
</style>